<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-building fa-1x push-5-r"></i>  {{unit.reference_name}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Unit Detail Information  -->
                    <div v-if="flagDisplayDetail===0" class="block">

                        <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-gear fa-1x push-5-r "></i>{{ labelButtonConfig[actualLanguage] }}</button>

                        <h2 class="block-title push">Detail</h2>


                        <div class="col-xs-12 push">

                          <div class="col-xs-12 push">
                            <div class="col-xs-12 col-md-9 align-center">
                              <h5>{{labelButton[actualLanguage]}}</h5>
                            </div>
                            <div class="col-xs-12 col-md-3">
                              <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="flagReadByInvoiceData">
                              <span></span>
                            </label>
                            </div>
                          </div>

                          <div class="col-xs-12 push">
                            <div class="col-xs-12 col-md-4">
                              <div class="input-daterange form-group row">
                                  <div class="input-date-time-picker" >
                                    <date-picker
                                        class="el-input__inner form-control"
                                        v-model="visualisationDateStart"
                                        type="date"
                                        placeholder=""
                                        clear-icon=""
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                    />
                                  </div>
                              </div>
                            </div>

                            <div class="col-xs-12 col-md-4">
                              <div class="input-daterange form-group row">
                                  <div class="input-date-time-picker" >
                                    <date-picker
                                        class="el-input__inner form-control"
                                        v-model="visualisationDateEnd"
                                        type="date"
                                        placeholder=""
                                        clear-icon=""
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                    />
                                  </div>
                              </div>
                            </div>

                            <div class="col-xs-12 col-md-4">
                                <button  type="button" @click="readUnitGraphData()" class="btn btn-default align-right" name="buttonAddPlanItem">
                                  {{ labelButtonReadGraph[actualLanguage] }}</button>
                            </div>
                          </div>

                          <div class="col-xs-12 push">

                            <div v-if="flagGraphDataIsUpdating" class="col-xs-12 col-md-12">
                              <spinner size="large"></spinner>
                            </div>

                            <div v-if="flagDisplayGraph" class="col-xs-12 col-md-12">
                                <div  class="col-xs-12 col-md-9">
                                  <graph-apex-pies :GraphData="pieChartData" ></graph-apex-pies>
                                </div>
                                <div  class="col-xs-12 col-md-3">
                                  <h4 class="align-center">{{labelSumCost[actualLanguage]}} : {{sumPeriodCosts}} $</h4>

                                  <div class="table-responsive push">
                                      <table class="table table-striped table-vcenter">
                                          <thead>
                                              <tr>
                                                  <th class="text-center" style="width: 75%;">Service</th>
                                                  <th class="text-center" style="width: 25%;">{{labelCost[actualLanguage]}}</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for= "(data,index) in pieChartData.Data">
                                                  <td class="font-w600 text-center">
                                                    {{pieChartData.Labels[index]}}
                                                  </td>
                                                  <td class="font-w600 text-center">
                                                    {{data}} $
                                                  </td>
                                              </tr>

                                          </tbody>
                                      </table>

                                  </div>


                                </div>
                            </div>

                          

                            <div v-if="flagDisplayGraph" class="col-xs-12 col-md-12">
                                <graph-apex-bars :GraphData="barChartDataUnit1" ></graph-apex-bars>
                            </div>

                            <div v-if="flagDisplayGraph" class="col-xs-12 col-md-12">
                                <graph-apex-bars :GraphData="barChartDataUnit2" ></graph-apex-bars>
                            </div>

                          </div>


                        </div>
                    </div>





                    <!-- Unit Detail Information  -->
                    <div v-else class="block">
                         <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-close fa-1x push-5-r "></i>{{ labelButtonConfigClose[actualLanguage] }}</button>                       

                        <h1 class="block-title push">Configuration {{labelUnit[actualLanguage]}} ID: {{ unit.unit_id}}</h1>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelRefenrenceName[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6 push">
                                <input v-model="unit.reference_name" class="form-control align-center" type="test"  placeholder="">
                          </div>


                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelUnitTags[actualLanguage]}}</h6>
                              <p>{{labelUnitTagsHelp[actualLanguage]}}</p>
                              <p>{{labelUnitTagsHelp2[actualLanguage]}}</p>
                              
                          </div>
                          <div class="col-xs-12 col-md-6 push">
                                <div class="form-group">
                                  <div class="col-sm-12">
                                      <select class="form-control" v-model=unit.unit_tags size="4" multiple>
                                          <option value="Aucun/None">Aucun/None</option>
                                          <option v-for="type in tagsList" :value="type.tagId">{{type.tagName}}</option>
                                      </select>
                                  </div>
                              </div>
                          </div>

                          <button  type="button" @click="saveUnitModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="unitIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 

                        </div>

                      <!-- Section qui affiche les spécification de l'unité  -->
                      <h1 class="block-title push">{{labelSpecificationSection[actualLanguage]}}</h1>
                      <div class="col-xs-12 col-md-12 push">
                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelSpecType[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                            <select class="form-control" v-model="unit.spec_type_id" size="1">
                                <option v-for="type in specTypeList" :value="type.list_id">{{type.description[actualLanguage]}}</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelSpecArea[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                            <select class="form-control" v-model="unit.spec_area_id" size="1">
                                <option v-for="area in specAreaList" :value="area.list_id">{{area.description[actualLanguage]}}</option>
                            </select>
                          </div>
                        </div>


                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelSpecYearOfConstruction[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                            <select class="form-control" v-model="unit.spec_building_construction_year_id" size="1">
                                <option v-for="yearOfConstruct in specYearOfConstructList" :value="yearOfConstruct.list_id">{{yearOfConstruct.description[actualLanguage]}}</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelSpecHeatingIncluded[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                              <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="unit.spec_heating_included">
                              <span></span> <p v-if="unit.spec_heating_included">{{labelActivated[actualLanguage]}}</p>
                              </label>
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelSpecHotIncludedIncluded[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                              <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="unit.spec_hot_water_included">
                              <span></span> <p v-if="unit.spec_hot_water_included">{{labelActivated[actualLanguage]}}</p>
                              </label>
                          </div>
                        </div>
                      </div>



                      <!-- Section qui affiche et permet de voir les attributions de services  -->
                        <h1 class="block-title push">{{labelUnitServiceAttributions[actualLanguage]}}</h1>

                        <div class="col-xs-12 col-md-12">
                          <h5 class="push">{{labelAddAttributionSection[actualLanguage]}}</h5>
                        </div>

                        <div class="col-xs-12 col-md-12 push">

                          <div class="col-xs-12 col-md-6">
                            <div v-if="bundleServiceIsLoading==false" class="form-group">
                                
                                <div class="col-sm-12">
                                    <select class="form-control" v-model=tempoService size="1">
                                        <option v-for="service in bundleServiceList" :value="service">{{service.reference_name}}</option>
                                    </select>
                                </div>
                            </div>

                          </div>


                          <div class="col-xs-12 col-md-3">
                                <div class="col-xs-6">
                                    <h6>Attribution(%)</h6>
                                </div>
                                <div class="col-xs-6">
                                      <input v-model="tempoAttribution" class="form-control align-center" type="test"  placeholder="">
                                </div>
                          </div>

                          <div class="col-xs-12 col-md-3">
                            <button  type="button" @click="addAttribution()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                              <i class="fa fa-plus fa-1x push-5-r "></i>{{ tableAttributionsAdd[actualLanguage] }}</button>
                          </div>
                        </div>



                        <div class="col-xs-12 col-md-12 push">
                          <div class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 65%;">{{tableAttributionsColumnTitle01[actualLanguage]}}</th>
                                          <th style="width: 25%;">{{tableAttributionsColumnTitle02[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 10%;">{{tableAttributionsColumnTitle03[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(attribution,index) in unit.service_attributions">
                                          <td class="font-w600">{{attribution.reference_name}}</td>
                                          <td>{{attribution.attribution}}</td>
                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteAttribution(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>

                                  </tbody>
                              </table>

                          </div>

                          <button  type="button" @click="saveUnitModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="unitIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 
                        </div>




                        <h1 class="block-title push">{{labelTitleSectionFixCosts[actualLanguage]}}</h1>
                        <div class="col-xs-12 col-md-12">
                          <p class="push-30">{{labelFixCostExplanation[actualLanguage]}}</p>

                          <div v-if="unit.fix_costs.length>0" class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%;">{{fixCostColumn01[actualLanguage]}}</th>
                                          <th style="width: 18%;">{{fixCostColumn02[actualLanguage]}}</th>
                                          <th style="width: 18%;">{{fixCostColumn03[actualLanguage]}}</th>
                                          <th style="width: 30%;">{{fixCostColumn04[actualLanguage]}}</th>
                                          <th style="width: 14%;">{{fixCostColumn05[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 10%;">{{fixCostColumn06[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(cost,index) in unit.fix_costs">
                                          <td class="font-w600">
                                            <div class="col-xs-12 col-sm-3">
                                                <label class="css-input switch switch-success">
                                                <input type="checkbox" checked v-model="cost.yearlyFlag">
                                                <span></span></label>
                                            </div>
                                          </td>
                                          <td>
                                            <div class="col-md-12">
                                              <div v-if="cost.yearlyFlag==false" class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodStart"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                              <div v-else class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodStart"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>
                                          <td>
                                             <div class="col-md-12">
                                              <div v-if="cost.yearlyFlag==false" class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodEnd"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                              <div v-else class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodEnd"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>
                                          <td>
                                            <div class="col-xs-12 col-sm-12 push">
                                                  <input v-model="cost.description" class="form-control align-center" type="test"  placeholder="">
                                            </div>
                                          </td>
                                          <td>
                                            <div class="col-xs-12 col-sm-12 push">
                                                  <input v-model="cost.cost" class="form-control align-center" type="test"  placeholder="">
                                            </div> 
                                          </td>
                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteFixCost(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>

                                  </tbody>
                              </table>

                          </div>

                          <div class="col-xs-12 col-md-12 push">
                            <button  type="button" @click="addFixCostLine()" class="btn btn-xs align-right push" name="buttonAddPlanItem">
                            <i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddFixCost[actualLanguage] }}</span></button> 
                          </div>

                          <button  type="button" @click="saveUnitModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="unitIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 
                        </div>




                        <h1 class="block-title push">Options</h1>
                        <div class="col-xs-12 col-md-12">

                            <div v-for="(category,index) in unit.options" class="col-xs-12 col-md-12 push">
                              <h5  class=""><u>{{category.categoryTitle[actualLanguage]}}</u></h5>
                              <p class="push-30">{{category.categoryDescription[actualLanguage]}}</p>

                              <div v-for="(Option,index2) in category.options" class="col-xs-12 col-md-12 push">

                                <div v-if="Option.valueType=='bool'" class="col-xs-12 col-md-12">

                                  <div class="col-xs-12 col-sm-9">
                                      <h5>{{Option.optionLabel[actualLanguage]}}</h5>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                      <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="Option.value">
                                      <span></span> <p v-if="Option.value">{{labelActivated[actualLanguage]}}</p>
                                      </label>
                                  </div>

                                </div>



                                <div v-if="Option.valueType=='stringNumber'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                        <input v-model="Option.value" class="form-control align-center" type="test"  placeholder="">
                                  </div>
                                </div>

                                <!-- --------------------------------- -->
                                <!-- SPECIFIC OPTIONS TYPES !! -->
                                <!-- --------------------------------- -->
                                <div v-if="Option.valueType=='compilationPeriodicity'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                    <select class="form-control" v-model="Option.value" size="1">
                                        <option v-for="option in periodicityOptions" :value="option.value">{{option.displayText[actualLanguage]}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div v-if="Option.valueType=='dayInMonthString'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                    <select class="form-control" v-model="Option.value" size="1">
                                        <option v-for="day in listDaysInMonth" :value="day">{{day}}</option>
                                    </select>
                                  </div>
                                </div>


                                <div v-if="Option.valueType=='compareLevelMessageList'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                    <select class="form-control" v-model="Option.value" size="1">
                                        <option v-for="list in messageList" :value="list.complement_id">{{list.referenceName}}</option>
                                    </select>
                                  </div>
                                </div>



                                <div v-if="Option.valueType=='listString'" class="col-xs-12 col-md-12">
                                  {{Option}}
                                </div>

                              </div>

                            </div>

                        </div>

                        <button  type="button" @click="saveUnitModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                        <spinner size="small" v-if="unitIsSaving"></spinner>
                        <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 



                    </div>

                    <!-- END Static Labels -->
                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import GraphApexBars from './GraphApexBars'
import GraphApexPies from './GraphApexPies'
import moment from 'moment';

export default {
  name: 'Unit',
  props: ['unit'],
 
  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      profileIsSaving : false,
      unitIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelTitleBanner: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelUnit: {FR: 'Unité', EN: 'Unit'},



      labelTitleGraph: {FR: "Mesures de l'unité", EN: 'Unit measurement'},
      flagReadByInvoiceData : false,
      labelButton: {FR: "Lire données selon les données de facturations de service",
                    EN: 'Read data according to service billing data'},
      visualisationDateStart : '',
      visualisationDateEnd : '',

      flagDisplayGraph : false,
      flagGraphDataIsUpdating : false,
      labelSumCost: {FR: "Coûts total", EN: 'Sum costs'},
      labelCost: {FR: "Coûts", EN: 'Costs'},
      labelButtonReadGraph: {FR: "Actualiser le graphique", EN: 'Refresh graph'},
      GraphData : [],
      barChartDataUnit1 : {ChartTitle:{FR: 'Coûts par jour par service',
                                     EN: 'Costs per day per service'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:true,StackType:"normal"}},

      barChartDataUnit2 : {ChartTitle:{FR: 'Répartition par jours',
                                     EN: 'Distribution by days'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:true,StackType:"100%"}},

      pieChartData : {ChartTitle:{FR: 'Répartition des coûts pour la période sélectionnée', EN: 'Breakdown of costs for the selected period'},
                      Labels : [],
                      Data : []},
      sumPeriodCosts : 0,



      labelButtonConfig: {FR: 'Configuration', EN: 'Configuration'},
      labelButtonConfigClose: {FR: 'Fermer configuration', EN: 'Close configuration'},
      labelButtonSaveModifications: {FR: 'Enregistrer modifications', EN: 'Save modifications'},
      labelUnitServiceAttributions: {FR: 'Attributions de services', EN: 'Service attribtions'},

      labelRefenrenceName: {FR: "Nom de référence de l'unité", EN: 'Unit reference name'},
      selectLabelLinkedChannel : {FR: "Appareil mesuré lié", EN: 'Linked monitored device'},

      tableAttributionsColumnTitle01: {FR: "Service liés", EN: "Linked Service"},
      tableAttributionsColumnTitle02: {FR: "Attribution (%)", EN: "Attribution (%)"},
      tableAttributionsColumnTitle03: {FR: "Supprimer", EN: "Delete"},

      labelAddAttributionSection: {FR: "Ajout d'attribution de service:", EN: "Add service attribution:"},
      tableAttributionsAdd: {FR: "Ajouter", EN: "Add"},
      tempoAttribution: '0',
      tempoService :{},
      bundleServiceIsLoading : false,
      selectLabelNewAttribution : {FR: "Services", EN: "Service"},
      bundleServiceList : [],


      labelSpecificationSection : {FR: "Spécifications de l'unité",
                                  EN: 'Unit spécification'},
      labelSpecType : {FR: "Type d'unité",
                        EN: 'Unit type'},
      labelSpecArea : {FR: "Superficie de l'unité",
                        EN: 'Unit area'},
      labelSpecYearOfConstruction : {FR: "Année de construction (ou de rénovation)",
                                      EN: 'Year of construction (or renovation)'},
      labelSpecHeatingIncluded : {FR: "Chauffage inclu dans les services",
                                  EN: 'Heating included in the services'},
      labelSpecHotIncludedIncluded : {FR: "Eau chaude incluse dans les services",
                                      EN: 'Hot water included in the services'},
      specAreaList : [],
      specTypeList:[],
      specYearOfConstructList : [],


      labelUnitTags: {FR: "Étiquette de l'unité (nécessaire pour les rapports de comparaison)", EN: 'Unit tags (necessary for comparison reports)'},
      labelUnitTagsHelp: {FR: "Maintenir la touche CTRL pour attribuer plusieurs étiquettes.",
                           EN: 'Hold CTRL to assign multiple labels.'},
      labelUnitTagsHelp2: {FR: "Vous pouvez définir les étiquettes dans la section COMPLÉMENTS.",
                           EN: 'You can define the labels in the COMPLEMENT section'},
      tagsList : [],
      messageList : [],

      labelFixCostExplanation: {FR: "Un coût fixe s'ajoute au relevé de consommation et s'applique pour la période mentionnée. Le coût total est divisé par le nombre de jour et ensuite calculé selon le nombre de jour du relevé. Un coût de type ANNUEL se voit répété a chaque années au mois et jour sélectionnés.",
                                 EN: "A fixed cost is added to the consumption statement and applies for the period mentioned. The total cost is divided by the number of days and then calculated according to the number of days of the statement. An ANNUAL type cost is repeated every year on the selected month and day."},
      labelTitleSectionFixCosts: {FR: "Coûts fixe", EN: 'Fixed costs'},
      labelButtonAddFixCost: {FR: 'Ajouter un coût fixe', EN: 'Add fixed cost'},
      fixCostColumn01: {FR: "Annuel", EN: 'Annual'},
      fixCostColumn02: {FR: "Date début", EN: 'Start date'},
      fixCostColumn03: {FR: "Date fin", EN: 'End date'},
      fixCostColumn04: {FR: "Description", EN: 'Description'},
      fixCostColumn05: {FR: "Coût total($)", EN: 'Total cost ($)'},
      fixCostColumn06: {FR: "Supprimer", EN: 'Delete'},

      labelActivated: {FR: "Activé", EN: 'Activated'},

      listDaysInMonth : ['01','02','03','04','05','06','07','08','09','10','11','11','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],
      periodicityOptions : [{'value':'Monthly','displayText':{FR: "Mensuel", EN: 'Monthly'}},
                            {'value':'BiMonthly','displayText':{FR: "Bi Mensuel", EN: 'Bi monthly'}}]

    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
    GraphApexBars,
    GraphApexPies,
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      this.getBundleServiceList()
      this.getUnitTags()
      this.getSpecLists()

      if (this.flagDisplayBanner==-1){this.readUnitGraphData()}
      
    },

  toggleConfigView(){
    this.flagDisplayDetail = ~this.flagDisplayDetail
  },


  saveUnitModifications(){
        var requestData = {'postAction':'SaveUnit',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'unitData':this.unit}
        this.unitIsSaving=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.unitIsSaving=false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.unitIsSaving=false
                  }
            })
    },


    getBundleServiceList(){
        var requestData = {'postAction':'GetBundleServices',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'unitData':this.unit}
        this.bundleServiceIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.bundleServiceList= response.data.BundleServiceList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            this.bundleServiceIsLoading= false
            })
    },


  getMessageListList(){

        var requestData = {'postAction':'GetMessageList',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.messageList = response.data.MessageList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },


  addAttribution(){
      this.tempoService.attribution = this.tempoAttribution

        var requestData = {'postAction':'AddUnitServiceAttribution',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'unitData':this.unit,
                          'serviceToAdd':this.tempoService}
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.unit.service_attributions= response.data.ServiceAttribution
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
  },

  deleteAttribution(index){

        var requestData = {'postAction':'RemoveUnitServiceAttribution',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'unitData':this.unit,
                          'indexToRemove':index}
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.unit.service_attributions= response.data.ServiceAttribution
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
  },

    getUnitTags(){

        var requestData = {'postAction':'GetUnitTags',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.tagsList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

    getSpecLists(){
        var requestData = {'postAction':'GetUnitSpecLists',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                //console.log(response.data)
                this.specAreaList = response.data.SpecAreaList
                this.specTypeList = response.data.SpecTypeList
                this.specYearOfConstructList = response.data.SpecYearOfConstructList
                //this.tagsList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },


    addFixCostLine(){
      this.unit.fix_costs.push({'yearlyFlag':false,
      'periodStart':'',
      'periodEnd':'',
      'description':'',
      'cost':''})
    },

    deleteFixCost(index){
      this.unit.fix_costs.splice(index,1)
    },


    readUnitGraphData(){
        this.flagDisplayGraph = false
        this.flagGraphDataIsUpdating = true
        var GraphReadPostAction = 'GetUnitGraphData'

        if (this.flagReadByInvoiceData){
          GraphReadPostAction = 'GetUnitGraphDataFromInvoices'
        }

        var requestData = {'postAction':GraphReadPostAction,
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'unitData':this.unit,
                          'dateStart':this.visualisationDateStart,
                          'dateEnd':this.visualisationDateEnd}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response.data)
              this.flagGraphDataIsUpdating = false
            if(response.data.Code=='OK'){
                this.GraphData = response.data.GraphData

                this.barChartDataUnit1.XData = response.data.BarData.unitXData
                this.barChartDataUnit1.YData = response.data.BarData.unitYData
                this.barChartDataUnit2.XData = response.data.BarData.unitXData
                this.barChartDataUnit2.YData = response.data.BarData.unitYData

                this.pieChartData.Labels = response.data.PieData.labels
                this.pieChartData.Data = response.data.PieData.data
                this.sumPeriodCosts = 0
                for (var m = 0; m < this.pieChartData.Data.length; m++){
                  this.sumPeriodCosts +=this.pieChartData.Data[m]
                }
                this.sumPeriodCosts = parseFloat(this.sumPeriodCosts.toFixed(2))

                this.flagDisplayGraph = true
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })

    },



    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.getBundleServiceList()
    this.getMessageListList()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    var thisDayUnix = (Math.floor(moment().unix()/(24*3600)))*(24*3600)
    this.visualisationDateStart =((thisDayUnix-7*24*3600) * 1000)
    this.visualisationDateEnd = (thisDayUnix * 1000)
  }
}
</script>





// WEBPACK FOOTER //
// UnitDisplay.vue?7584549a